// Swaps the browser tab title/icon away from the static TestAssessify defaults
// in public/index.html. Used for culture audit, which is fully client-branded.
// public/index.html runs the same logic inline before React mounts, so a
// refresh never flashes TestAssessify; this keeps it in sync after login.
export const applyDocumentBranding = (brandingResponse) => {
  const data = brandingResponse?.data || {};
  const appearance = data.appearance || {};

  const name = data.name || appearance.company_name;
  document.title = name ? `${name} Culture Survey` : "Culture Survey";

  const icon = appearance.favicon || appearance.mobile_logo || appearance.desktop_logo;
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  // Empty data URI rather than the TestAssessify favicon when there's no logo.
  link.href = icon || "data:,";
};
